import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { fetchData, postData } from "../../services/apiServices";
import QRCode from "react-qr-code";

const WithdrawDetails = () => {
  const { id } = useParams();
  const [status, setStatus] = useState("Pending");
  const [reason, setReason] = useState("");
  const [transactionId, setTransactionId] = useState("");
  const [singleTransaction, setSingleTransaction] = useState();
  const [adminBalance, setAdminBalance] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const getSingleTransaction = async () => {
    try {
      const response = await fetchData(`api/wallet/withdraws/${id}`);
      setSingleTransaction(response.withdraw);
    } catch (error) {
      console.error("Error fetching transaction:", error);
    }
  };

  const getAdminBalance = async () => {
    try {
      if (singleTransaction?.chain) {
        const response = await fetchData(`api/wallet/adminBalances/${singleTransaction.chain}`);
        setAdminBalance(response);
      }
    } catch (error) {
      console.error("Error fetching admin balance:", error);
      setAdminBalance(null);
    }
  };

  useEffect(() => {
    getSingleTransaction();
  }, []);

  useEffect(() => {
    if (singleTransaction?.chain) {
      getAdminBalance();
    }
  }, [singleTransaction?.chain]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const payload = { id: id };

      const response = await postData(`api/wallet/approveWithdraw`, payload);

      if (!response.success) {
        throw new Error(response.message || "Something went wrong");
      }

      alert(response.message);
      getSingleTransaction(); // Refresh UI
    } catch (err) {
      console.error("Submit error:", err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  // Calculate if admin has sufficient balance
  const hasSufficientBalance = () => {
    if (!adminBalance || !singleTransaction) return true;
    
    const token = singleTransaction.withdrawToken?.toUpperCase() || 'USDT';
    const requiredAmount = singleTransaction.amount;
    const availableBalance = adminBalance[token] || 0;
    
    return availableBalance >= requiredAmount;
  };

  const getTokenBalance = () => {
    if (!adminBalance || !singleTransaction) return 'Loading...';
    
    const token = singleTransaction.withdrawToken?.toUpperCase() || 'USDT';
    return adminBalance[token] || 0;
  };

  return (
    <div className="page-content">
      <button className="btn btn-warning mb-3" onClick={() => navigate(-1)}>Back</button>
      <div className="container my-5">
        <h3 className="mb-4">Transaction Details</h3>

        <div className="row mb-2">
          <div className="col-4 fw-bold">Username:</div>
          <div className="col-8">{singleTransaction?.user?.username}</div>
        </div>
        <div className="row mb-2">
          <div className="col-4 fw-bold">Email:</div>
          <div className="col-8">{singleTransaction?.user?.email}</div>
        </div>
        <div className="row mb-2">
          <div className="col-4 fw-bold">Amount:</div>
          <div className="col-8">{singleTransaction?.amount}</div>
        </div>
        <div className="row mb-2">
          <div className="col-4 fw-bold">Currency:</div>
          <div className="col-8">{singleTransaction?.withdrawToken || "usdt"}</div>
        </div>
        <div className="row mb-2">
          <div className="col-4 fw-bold">Chain:</div>
          <div className="col-8">{singleTransaction?.chain}</div>
        </div>
        <div className="row mb-2">
          <div className="col-4 fw-bold">Receive Address:</div>
          <div className="col-8">{singleTransaction?.address}</div>
        </div>

        {/* Admin Balance Check */}
        {adminBalance && (
          <div className="row mb-3">
            <div className="col-12">
              <div className={`alert ${hasSufficientBalance() ? 'alert-success' : 'alert-danger'}`}>
                <strong>Admin Balance Check:</strong><br />
                Available {singleTransaction?.withdrawToken?.toUpperCase() || 'USDT'}: {getTokenBalance()}<br />
                Required: {singleTransaction?.amount}<br />
                Status: {hasSufficientBalance() ? '✅ Sufficient Balance' : '❌ Insufficient Balance'}
              </div>
            </div>
          </div>
        )}

        <form onSubmit={handleSubmit}>
          {error && <div className="alert alert-danger mb-3">{error}</div>}

          <button 
            type="submit" 
            className="btn btn-warning mb-3"
            disabled={loading || !hasSufficientBalance()}
          >
            {loading ? 'Processing...' : 'Approve Withdrawal'}
          </button>

          {!hasSufficientBalance() && (
            <div className="alert alert-warning">
              Cannot process withdrawal: Admin has insufficient balance
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default WithdrawDetails;